import { render, staticRenderFns } from "./DailyChatLogo.vue?vue&type=template&id=661d67ae&scoped=true&"
import script from "./DailyChatLogo.vue?vue&type=script&lang=js&"
export * from "./DailyChatLogo.vue?vue&type=script&lang=js&"
import style0 from "./DailyChatLogo.vue?vue&type=style&index=0&id=661d67ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d67ae",
  null
  
)

export default component.exports